<template>
  <div>
    <v-dialog v-model="alertDialog" max-width="900">
      <ManageAlert
        title="Novo alerta"
        :alert="alert"
        :newAlert="true"
        @close="closeDialog"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="alterDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="white"
          style="width: 100%"
        >
          <h3 class="mb-1">{{ $t('Atenção') }}</h3>
          <v-divider class="mb-2"></v-divider>
          <p class="text-body-2 black--text text--darken-1 mb-4">
            {{ $t('Os dados informados não serão salvos, deseja continuar?') }}
          </p>

          <div class="d-flex justify-space-between">
            <v-btn
              depressed
              :disabled="loading"
              class="ma-1 secondary-button"
              style="color: white; background-color: #b14949 !important"
              @click="alterDialog = false"
            >
              {{ $t('Não') }}
            </v-btn>

            <v-btn
              depressed
              :loading="loading"
              class="ma-1 primary-button"
              style="color: white; background-color: #0f3582 !important"
              @click="closeDialog"
            >
              {{ $t('Sim') }}
            </v-btn>
          </div>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="supplierDialog" max-width="900px">
      <ManageSupplier
        title="Novo fornecedor"
        @close="closeDialog"
        :key="dialogKey"
      />
    </v-dialog>

    <v-card class="card-pad d-flex align-center mb-4" height="75">
      <v-btn depressed small text color="grey" @click="close">
        <v-icon x-small>mdi-arrow-left-bold</v-icon>
        {{ $t('Voltar') }}
      </v-btn>
    </v-card>

    <InstitutionInactive v-if="institutionInactive" />

    <v-window v-model="step" touchless>
      <v-window-item :value="0">
        <v-form
          class="form"
          ref="firstForm"
          v-model="firstValid"
          lazy-validation
          :disabled="institutionInactive"
        >
          <v-card class="card-pad pa-0 mt-4">
            <v-row class="ma-0 px-4" dense justify="end">
              <v-col class="d-flex align-center my-2">
                <strong>{{ $t('Dados gerais') }}</strong>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="ma-0 px-3" dense>
              <v-col class="pb-0" cols="12" sm="3">
                <label class="label">{{ $t('Instituição') }}</label>
                <v-text-field
                  hide-details="auto"
                  v-model="institution.name"
                  disabled
                  outlined
                  class="primary-input"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0" cols="12" sm="3">
                <label class="label">{{ $t('Unidade') }}</label>
                <v-autocomplete
                  hide-details="auto"
                  v-model="unidadeIds"
                  :rules="unidadeRules"
                  :items="unidades"
                  multiple
                  item-text="name"
                  item-value="id"
                  :loading="unidadeLoading"
                  outlined
                  class="primary-input"
                >
                  <template #message="{ message }">
                    {{ $t(message) }}
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col class="pb-0" cols="12" sm="3">
                <label class="label">{{ $t('Setor') }}</label>
                <v-autocomplete
                  :disabled="unidadeIds.length == 0"
                  hide-details="auto"
                  multiple
                  v-model="currentContract.departments"
                  :items="
                    departments.filter((x) => unidadeIds.includes(x.unidadeId))
                  "
                  item-text="name"
                  item-value="id"
                  :loading="departmentLoading"
                  :rules="[
                    (v) => (!!v && v.length > 0) || 'Setor(es) obrigatórios',
                  ]"
                  outlined
                  class="primary-input"
                >
                  <template v-slot:item="{ item }">
                    <span class="text-caption" v-if="item.unidade">
                      {{ item.name }} / {{ item.unidade.name }}
                    </span>
                    <span class="text-caption" v-else>
                      {{ item.name }}
                    </span>
                  </template>

                  <template #message="{ message }">
                    {{ $t(message) }}
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col class="pb-0" cols="12" sm="3">
                <label class="label">{{ $t('Nº contrato') }}</label>
                <v-text-field
                  hide-details="auto"
                  v-model="currentContract.number"
                  :rules="numberRules"
                  required
                  outlined
                  class="primary-input"
                >
                  <template #message="{ message }">
                    {{ $t(message) }}
                  </template>
                </v-text-field>
              </v-col>
              <v-col class="pb-0" cols="7" sm="2" md="2" lg="2">
                <label class="label">{{ $t('Valor Mensal Contrato') }}</label>
                <vuetify-money
                  v-model="currentContract.value"
                  backgroundColor=""
                  :disabled="isInputable"
                  outlined
                  hide-details
                  class="primary-input"
                ></vuetify-money>
              </v-col>
              <v-col class="pb-0" cols="3" sm="2" md="2" lg="2">
                <div class="d-flex justify-space-between ml-1 mt-2">
                  <v-switch inset v-model="isInputable"></v-switch>
                  <label class="label d-flex justify-center mt-2">{{
                    $t('Utilizar valor como soma dos equipamentos')
                  }}</label>
                </div>
              </v-col>

              <v-col class="pb-0" cols="5" sm="2" md="2" lg="2">
                <label class="label">{{ $t('Quantidade') }}</label>
                <v-text-field
                  hide-details="auto"
                  v-model="currentContract.quantity"
                  readonly
                  disabled
                  outlined
                  class="primary-input"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0" cols="12" sm="6" md="6" lg="6">
                <label class="label">{{ $t('Contrato (apelido)') }}</label>
                <v-text-field
                  hide-details="auto"
                  v-model="currentContract.name"
                  :rules="nameRules"
                  required
                  outlined
                  class="primary-input"
                >
                  <template #message="{ message }">
                    {{ $t(message) }}
                  </template>
                </v-text-field>
              </v-col>
              <v-col class="pb-0" cols="12" sm="6" md="6" lg="6">
                <label class="label">{{ $t('Cobertura') }}</label>
                <v-autocomplete
                  hide-details="auto"
                  v-model="currentContract.eContractCoverages"
                  :rules="coverageRules"
                  :items="coverages"
                  multiple
                  item-text="text"
                  item-value="value"
                  outlined
                  class="primary-input"
                >
                  <template
                    v-slot:selection="{ attrs, item, select, selected }"
                  >
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      color="#BBCF20"
                      text-color="#fff"
                      small
                      @click="select"
                      @click:close="removeCoverage(item)"
                    >
                      <span class="text-caption" style="text-transform: none">
                        {{ $t(item.text) }}
                      </span>
                    </v-chip>
                  </template>

                  <template v-slot:item="{ item }">
                    <span class="text-caption">
                      {{ $t(item.text) }}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col class="pb-0" cols="12" sm="6" md="6" lg="3">
                <label class="label">{{ $t('Índice reajuste') }}</label>
                <v-text-field
                  hide-details="auto"
                  v-model="currentContract.indexReadjustment"
                  outlined
                  class="primary-input"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0" cols="12" sm="6" md="6" lg="3">
                <label class="label">{{ $t('Horário cobertura') }}</label>
                <v-text-field
                  hide-details="auto"
                  v-model="currentContract.coverageTime"
                  type="number"
                  outlined
                  class="primary-input"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0" cols="12" sm="6" md="6" lg="3">
                <label class="label">{{
                  $t('Tempo de Atendimento Presencial')
                }}</label>
                <v-text-field
                  hide-details="auto"
                  v-model="currentContract.serviceTime"
                  suffix="Hrs"
                  type="number"
                  outlined
                  class="primary-input"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0" cols="12" sm="6" md="6" lg="3">
                <label class="label">{{
                  $t('Tempo de Atendimento Remoto')
                }}</label>
                <v-text-field
                  hide-details="auto"
                  v-model="currentContract.remoteServiceTime"
                  suffix="Hrs"
                  type="number"
                  outlined
                  class="primary-input"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0" cols="12" sm="6" md="6" lg="3">
                <label class="label">{{ $t('Cláusula uptime') }}</label>
                <v-text-field
                  hide-details="auto"
                  v-model="currentContract.uptimeClause"
                  suffix="%"
                  type="number"
                  outlined
                  class="primary-input"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0" cols="12" sm="6" md="6" lg="3">
                <v-menu
                  ref="menuStartDate"
                  v-model="menuStartDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <label class="label">{{ $t('Ínicio vigência') }}</label>
                    <v-text-field
                      hide-details="auto"
                      v-model="startDate"
                      v-mask="['##/##/####']"
                      prepend-inner-icon="mdi-calendar"
                      @blur="currentContract.startDate = parseDate(startDate)"
                      :rules="startDateRules"
                      v-bind="attrs"
                      v-on="on"
                      autocomplete="off"
                      outlined
                      class="primary-input"
                    >
                      <template #message="{ message }">
                        {{ $t(message) }}
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="currentContract.startDate"
                    min="1900-01-01"
                    @change="save"
                    no-title
                    locale="pt"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="pb-0" cols="12" sm="6" md="6" lg="3">
                <v-menu
                  ref="menuEndDate"
                  v-model="menuEndDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <label class="label">{{ $t('Fim vigência') }}</label>
                    <v-text-field
                      hide-details="auto"
                      v-model="endDate"
                      v-mask="['##/##/####']"
                      prepend-inner-icon="mdi-calendar"
                      @blur="currentContract.endDate = parseDate(endDate)"
                      :rules="endDateRules"
                      v-bind="attrs"
                      v-on="on"
                      autocomplete="off"
                      outlined
                      class="primary-input"
                    >
                      <template #message="{ message }">
                        {{ $t(message) }}
                      </template>
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              depressed
                              :disabled="!endDate"
                              x-small
                              color="#DC143C"
                              v-bind="attrs"
                              v-on="on"
                              @click="createAlertContractEndDate"
                            >
                              <v-icon small>mdi-bell-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('Criar alerta') }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="currentContract.endDate"
                    :min="minEndDate"
                    @change="save"
                    no-title
                    locale="pt"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="3">
                <v-menu
                  ref="menuReadjustmentDate"
                  v-model="menuReadjustmentDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <label class="label">{{ $t('Data reajuste') }}</label>
                    <v-text-field
                      hide-details="auto"
                      v-model="readjustmentDate"
                      v-mask="['##/##/####']"
                      prepend-inner-icon="mdi-calendar"
                      @blur="
                        currentContract.readjustmentDate =
                          parseDate(readjustmentDate)
                      "
                      :rules="readjustmentDateRules"
                      v-bind="attrs"
                      v-on="on"
                      autocomplete="off"
                      outlined
                      class="primary-input"
                    >
                      <template #message="{ message }">
                        {{ $t(message) }}
                      </template>
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              depressed
                              :disabled="!readjustmentDate"
                              x-small
                              color="#DC143C"
                              v-bind="attrs"
                              v-on="on"
                              @click="createAlertReadjustmentDate"
                            >
                              <v-icon small>mdi-bell-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('Criar alerta') }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="currentContract.readjustmentDate"
                    min="1900-01-01"
                    @change="save"
                    no-title
                    locale="pt"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="pb-0" cols="10" sm="5" md="5" lg="5">
                <label class="label">{{ $t('Fornecedor') }}</label>
                <v-autocomplete
                  hide-details="auto"
                  v-model="supplierId"
                  :items="suppliers"
                  item-text="name"
                  item-value="id"
                  outlined
                  class="primary-input"
                ></v-autocomplete>
              </v-col>
              <v-col class="mt-8" cols="1" sm="1" md="1" lg="1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      color="#BBCF20"
                      height="30"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      @click="addSupplier"
                      :disabled="institutionInactive"
                    >
                      <v-icon dark> mdi-plus </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('Novo fornecedor') }}</span>
                </v-tooltip>
              </v-col>
              <v-col class="py-0" cols="12">
                <label class="label">{{ $t('Observação') }}</label>
                <v-textarea
                  hide-details="auto"
                  no-resize
                  rows="3"
                  v-model="currentContract.observation"
                  outlined
                  class="text-area-input"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card-actions v-if="!institutionInactive">
              <v-btn
                @click="close"
                depressed
                v-if="step === 0"
                class="quaternary-button ml-4"
                color="#FF4F64"
              >
                {{ $t('Cancelar') }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                @click="next"
                class="mr-4 primary-button"
                :loading="loading"
              >
                {{ $t(buttonText) }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-window-item>
    </v-window>

    <v-card class="card-pad pa-0 mt-4">
      <v-row class="ma-0 px-4" dense justify="end">
        <v-col class="d-flex align-center my-2">
          <strong>{{ $t('Equipamentos cobertos') }}</strong>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-data-table
        :headers="headersMobile"
        :items="currentContract.equipment"
        class="main-table mt-3 hidden-md-and-up"
        hide-default-footer
        :items-per-page="
          currentContract.equipment ? currentContract.equipment.length : 0
        "
        :mobile-breakpoint="330"
        :single-expand="false"
        :expanded.sync="expanded"
        @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
      >
        <template #[`item.identification`]="{ item }">
          <span :style="item.alienated ? 'color: red' : ''">
            {{
              item.identification != null ? item.identification : 'Sem registro'
            }}
          </span>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong> Eq.padrão: </strong>
                {{
                  item.standardEquipment
                    ? item.standardEquipment.name
                    : $t('Sem registros')
                }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong> Modelo: </strong>
                {{ item.model }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong> Status Equipamento: </strong>
                {{ getDepartmentStatus(item.departmentId) }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="11">
              <v-text-field
                hide-details
                class="inputValor"
                label="Valor"
                type="number"
                v-model.number="item.contractValue"
                outlined
              >
              </v-text-field>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>Ações: </strong>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-1"
                      color="#0F3565"
                      @click="editEquipment(item)"
                      v-bind="attrs"
                      v-on="on"
                      small
                      :loading="alterEquipmentLoading"
                      :disabled="institutionInactive"
                    >
                      <v-icon small> mdi-content-save-edit-outline </v-icon>
                    </v-btn>
                  </template>
                  <span>Salvar alteração valor</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-1"
                      small
                      color="#A42A2AD9"
                      v-bind="attrs"
                      @click="removeEquipmentOfContract(item)"
                      v-on="on"
                      :loading="alterEquipmentLoading"
                      :disabled="institutionInactive"
                    >
                      <v-icon small> mdi-text-box-remove-outline </v-icon>
                    </v-btn>
                  </template>
                  <span>Remover equipamento</span>
                </v-tooltip>
              </p>
            </v-col>
          </td>
        </template>
      </v-data-table>

      <p class="label mx-3 mt-2 mb-0">
        {{
          $t(
            '*Equipamentos alienados são marcados com a identificação em vermelho'
          )
        }}
      </p>
      <v-data-table
        :headers="headers"
        :items="currentContract.equipment"
        :items-per-page="
          currentContract.equipment ? currentContract.equipment.length : 0
        "
        class="main-table ma-3 hidden-sm-and-down"
        hide-default-footer
        hide-default-header
      >
        <template #header="{ props, on }">
          <thead>
            <tr>
              <th
                class="text-center"
                v-for="header in props.headers"
                :key="header.value"
              >
                <v-simple-checkbox
                  v-if="header.value === 'data-table-select'"
                  v-model="props.everyItem"
                  :indeterminate="props.someItems && !props.everyItem"
                  color="purple"
                  @input="on['toggle-select-all']"
                ></v-simple-checkbox>

                <div>
                  <v-hover v-slot="{ hover }">
                    <div>
                      <span>{{ $t(header.text) }}</span>
                      <v-icon
                        v-if="
                          hover &&
                          header.value != 'data-table-select' &&
                          header.value != 'actions'
                        "
                        color="white"
                        class="mx-2"
                        @click="on.sort(header.value)"
                      >
                        {{
                          props.options.sortBy.includes(header.value)
                            ? `mdi-chevron-down`
                            : `mdi-chevron-up`
                        }}
                      </v-icon>
                    </div>
                  </v-hover>
                </div>
              </th>
            </tr>
          </thead>
        </template>

        <template #[`item.identification`]="{ item }">
          <span :style="item.alienated ? 'color: red' : ''">
            {{
              item.identification != null
                ? item.identification
                : $t('Sem registro')
            }}
          </span>
        </template>
        <template #[`item.standardEquipment`]="{ item }">
          {{
            item.standardEquipment
              ? item.standardEquipment.name
              : $t('Sem registros')
          }}
        </template>
        <template #[`item.model`]="{ item }">
          {{ item.model != null ? item.model : $t('Sem registro') }}
        </template>
        <template #[`item.statusEquipment`]="{ item }">
          {{ $t(getDepartmentStatus(item.departmentId)) }}
        </template>
        <template #[`item.contractValue`]="{ item }">
          <v-currency-field
            v-model="item.contractValue"
            backgroundColor=""
            outlined
            hide-details
            class="primary-input my-2"
            @blur="editEquipment(item)"
            prefix="R$"
          ></v-currency-field>
        </template>
        <template #[`item.contractDollarValue`]="{ item }">
          <vuetify-money
            v-model="item.contractDollarValue"
            backgroundColor=""
            outlined
            hide-details
            class="primary-input my-2"
            v-bind:options="{
              locale: 'en',
              prefix: 'US$',
              length: 15,
              precision: 2,
              empty: null,
            }"
          ></vuetify-money>
        </template>
        <template #[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                small
                color="#FF4F64"
                style="font-weight: bold"
                dark
                v-bind="attrs"
                @click="removeEquipmentOfContract(item)"
                v-on="on"
                :loading="alterEquipmentLoading"
                :disabled="institutionInactive"
              >
                <v-icon small> mdi-text-box-remove-outline </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Remover equipamento') }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <v-divider></v-divider>

    <v-card-actions v-if="step === 1" class="back">
      <v-spacer></v-spacer>
      <v-btn color="#426483" depressed @click="next" :loading="loading">
        {{ buttonText }}
      </v-btn>
    </v-card-actions>
  </div>
</template>

<style scoped>
.equipmentField {
  width: 90%;
  text-align: center !important;
  align-content: center;
}

.form {
  margin: auto;
  border-radius: 5px;
  background-color: #ffffff;
}

.table {
  max-width: 90% !important;
  margin: 2rem auto;
  background-color: #ffffff;
}

.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}

.primary-input >>> .v-input__slot {
  border-radius: var(--primary-input-border-radius) !important;
}

.primary-input >>> .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}

.v-picker.v-card
  >>> .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(
    .v-btn--outlined
  ) {
  background-color: #ffffff;
}

@media (max-width: 600px) {
  .v-card__text {
    padding: 0;
  }
}
</style>

<script>
import ApiService from '../../../../services/ApiService'
import GeneralService from '../../../../services/GeneralService'
import Utils from '../../../../Utils/FormatDate'
import ManageSupplier from '../../../pages/Suppliers/components/ManageSupplier.vue'
import ManageAlert from '../../Alert/components/manageAlert/ManageAlert.vue'
import InstitutionInactive from '../../Institutions/components/institutionInactive/institutionInactive.vue'

export default {
  props: {
    contractId: String,
  },

  components: {
    ManageSupplier,
    ManageAlert,
    InstitutionInactive,
  },

  async created() {
    window.scrollTo(0, 0)
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionInactive = this.institution.status == 1
    this.currentUser = JSON.parse(localStorage.getItem('user'))

    if (this.institution.userType > 1) {
      await this.getUserUnidades()
    } else {
      await this.getUnidades()
    }

    this.getSuppliers()
    this.getDepartments()
    if (this.contractId) {
      this.getContract()
    }
  },

  data: () => ({
    departmentLoading: false,
    expanded: [],
    step: 0,
    errorMessage: '',
    alterEquipmentLoading: false,
    isRemoveEquipment: false,
    loading: false,
    supplierLoading: false,
    unidadeLoading: false,
    firstValid: true,
    secondValid: true,
    thirdValid: true,
    alterDialog: false,
    alertDialog: false,
    changedData: false,
    isEditing: false,
    inputDisabled: true,
    error: false,
    menuStartDate: false,
    menuEndDate: false,
    menuReadjustmentDate: false,
    supplierDialog: false,
    dialogKey: false,
    institutionInactive: false,
    startDate: null,
    endDate: null,
    readjustmentDate: null,
    institution: {},
    unidadeIds: [],
    unidades: [],
    supplierId: null,
    suppliers: [],
    standardEquipments: [],
    currentEquipment: {},
    alert: {},
    departments: [],
    coverages: [
      { text: 'Validação de equipamentos', value: 0 },
      { text: 'Outros', value: 1 },
      { text: 'Manutenção preventiva', value: 2 },
      { text: 'Manutenção corretiva', value: 3 },
      { text: 'Locação / Comodato', value: 4 },
      { text: 'Calibração', value: 6 },
    ],
    currentContract: {
      id: 0,
      name: '',
      number: '',
      indexReadjustment: '',
      serviceTime: '',
      startDate: null,
      endDate: null,
      value: '',
      quantity: '',
      coverage: null,
      coverageTime: '',
      uptimeClause: '',
      readjustmentDate: null,
      observation: '',
    },
    isInputable: false,
    nameRules: [
      (v) =>
        !v ||
        v.length <= 128 ||
        'Nome/Apelido do contrato deve ter no máximo 128 caracteres',
    ],
    numberRules: [
      (v) => !!v || 'Número do contrato requerido',
      (v) =>
        (v && v.length <= 30) ||
        'Número do contrato deve ter no máximo 30 caracteres',
    ],
    unidadeRules: [(v) => !!v || 'Unidade é requerida'],
    coverageRules: [(v) => v != -1 || 'Cobertura é requerida'],
    startDateRules: [(v) => !!v || 'Data início é requerida'],

    readjustmentDateRules: [(v) => !!v || 'Data de reajuste é requerida'],
    departments: [],
    apiService: new ApiService(),
    headers: [
      {
        text: '',
        align: 'center',
        value: '',
        sortable: false,
      },
      {
        text: 'Nº identificação',
        align: 'center',

        value: 'identification',
        sortable: false,
      },
      {
        text: 'Equipamento padrão',
        align: 'center',

        value: 'standardEquipment',
        sortable: false,
      },
      {
        text: 'Modelo',
        align: 'center',

        value: 'model',
        sortable: false,
      },
      {
        text: 'Satus equipamento',
        align: 'center',

        value: 'statusEquipment',
        sortable: false,
      },
      {
        text: 'Valor',

        align: 'center',
        width: '200',
        value: 'contractValue',
        sortable: false,
      },
      {
        text: 'Valor (Dólar)',
        align: 'center',
        width: '200',
        value: 'contractDollarValue',
        sortable: false,
      },
      {
        text: 'Ações',

        align: 'center',
        value: 'actions',
        sortable: false,
      },
    ],
    headersMobile: [
      {
        text: 'Nº identificação',
        align: 'center',

        value: 'identification',
        sortable: false,
      },
    ],
    generalService: new GeneralService(),
  }),

  computed: {
    endDateRules() {
      return [
        (v) => !!v || 'Data final é requerida',
        (v) => this.validateEndDate(v),
      ]
    },
    minEndDate() {
      if (!this.currentContract?.startDate) return null

      const d = new Date(this.currentContract.startDate)
      d.setDate(d.getDate() + 1)
      return d.toISOString().substring(0, 10)
    },

    currentTitle() {
      switch (this.step) {
        case 0:
          return 'Dados gerais'
        default:
          return this.isEditing ? 'Atualização efetuada' : 'Cadastro efetuado'
      }
    },

    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    validateEndDate() {
      if (!this.currentContract?.startDate || !this.currentContract?.endDate)
        return true

      return (
        new Date(this.currentContract.endDate) >
          new Date(this.currentContract.startDate) ||
        'A data final deve ser maior que a data de início'
      )
    },

    removeCoverage(item) {
      this.currentContract.eContractCoverages.splice(
        this.currentContract.eContractCoverages.indexOf(item),
        1
      )
      this.currentContract.eContractCoverages = [
        ...this.currentContract.eContractCoverages,
      ]
    },

    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institution.id}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    close() {
      sessionStorage.clear()
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.go(-1)
      }
    },

    closeDialog() {
      if (this.supplierDialog) {
        this.supplierDialog = false
        this.getSuppliers()
      } else if (this.alertDialog) {
        this.alertDialog = false
      } else {
        this.changedData = false
        this.close()
      }
    },

    editEquipment(equipment) {
      this.currentEquipment = equipment
      this.alterEquipment()
    },

    removeEquipmentOfContract(equipment) {
      this.currentEquipment = equipment
      this.isRemoveEquipment = true
      this.alterEquipment()
    },

    addSupplier() {
      this.dialogKey = !this.dialogKey
      this.supplierDialog = true
    },

    createAlertReadjustmentDate() {
      this.alert = {
        description: `Data de reajuste do contrato - ${this.currentContract.number}`,
        eventDate: Utils.nowDatetimeFormat(
          this.parseDate(this.readjustmentDate)
        ),
        alertModule: 2,
        contractId: this.currentContract.id,
      }

      this.dialogKey = !this.dialogKey
      this.alertDialog = true
    },

    createAlertContractEndDate() {
      const supplier = this.suppliers.find((x) => x.id == this.supplierId)
      this.alert = {
        description: `Data de encerramento do contrato - ${
          this.currentContract.number
        } ${supplier ? '/ Fornecedor - ' + supplier.name : ''}`,
        eventDate: Utils.nowDatetimeFormat(this.parseDate(this.endDate)),
        alertModule: 2,
        contractId: this.currentContract.id,
      }

      this.dialogKey = !this.dialogKey
      this.alertDialog = true
    },

    async getContract() {
      await this.apiService
        .get(`contract/${this.institution.id}/${this.contractId}`)
        .then((response) => {
          this.currentContract = response.content
          this.currentContract.departments = response.content.departments.map(
            (x) => x.departmentId
          )
          this.startDate = this.formatInitialDate(response.content.startDate)
          this.endDate = this.formatInitialDate(response.content.endDate)
          this.readjustmentDate = this.formatInitialDate(
            response.content.readjustmentDate
          )
          this.unidadeIds = this.currentContract.unidades.map(
            (x) => x.unidadeId
          )
          this.supplierId = response.content.supplierId
          this.currentContract.value = response.content.value

          this.isInputable = response.content.isInputable
          this.isEditing = true
          this.getStandardEquipment()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          if (err.status === 404) {
            this.$router.push('/contracts')
          }

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institution.id}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getSuppliers() {
      this.supplierLoading = true

      await this.apiService
        .get(`supplier/list/${this.institution.id}`)
        .then((response) => {
          this.suppliers = response.content
          // this.suppliers.unshift({
          //   id: 0,
          //   name: "",
          // });
          this.supplierLoading = false
        })
    },

    async getStandardEquipment() {
      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institution.id
        )
    },

    async getDepartments() {
      this.departmentLoading = true
      await this.apiService
        .get(`department/list/${this.institution.id}`)
        .then((response) => {
          this.departments = response.content
          this.departmentLoading = false
        })
        .catch(() => {
          this.departmentLoading = false
        })
    },

    getDepartmentStatus(departmentId) {
      const department = this.departments.find((x) => x.id == departmentId)

      if (department) {
        switch (department.status) {
          case 0:
            return 'Ativo'
          default:
            return 'Inativo'
        }
      }
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          this.submit()
        }
      } else {
        this.close()
      }
    },

    async submit() {
      this.loading = true

      const contract = {
        Id: this.currentContract.id,
        Unidades: this.unidadeIds.map((x) => {
          return {
            unidadeId: x,
          }
        }),
        InstitutionId: this.institution.id,
        Number: this.currentContract.number,
        Name: this.currentContract.name,
        IndexReadjustment: this.currentContract.indexReadjustment,
        ServiceTime: this.currentContract.serviceTime,
        RemoteServiceTime: this.currentContract.remoteServiceTime,
        isInputable: this.isInputable,
        StartDate: this.currentContract.startDate,
        EndDate: this.currentContract.endDate,
        SupplierId: this.supplierId < 1 ? null : this.supplierId,
        eContractCoverages: this.currentContract.eContractCoverages,
        CoverageTime: this.currentContract.coverageTime,
        UptimeClause:
          this.currentContract.uptimeClause === ''
            ? 0
            : this.currentContract.uptimeClause,
        ReadjustmentDate: this.currentContract.readjustmentDate,
        Observation: this.currentContract.observation,
        Value: this.currentContract.value ? this.currentContract.value : 0,
        Departments: this.departments
          .filter(
            (x) =>
              this.unidadeIds.includes(x.unidadeId) &&
              this.currentContract.departments.includes(x.id)
          )
          .map((x) => {
            return {
              departmentId: x.id,
            }
          }),
      }

      let url = 'contract/add'

      if (this.isEditing) {
        url = 'contract/edit'
      } else {
        await this.addAlertContractEndDate()
      }

      await this.apiService
        .post(url, contract)
        .then(() => {
          this.closeDialog()
        })
        .catch((err) => {
          window.scrollTo(0, 0)
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
      this.changedData = false
    },

    async addAlertContractEndDate() {
      const eventDate = new Date(this.currentContract.endDate)
      const alert = {
        Id: 0,
        Description: `O contrato ${this.currentContract.number} está próximo do vencimento.`,
        EventDateTime: eventDate,
        AlertDateTime: Utils.removeDays(eventDate, 7),
        AlertModule: 2,
        Status: 0,
        UserId: JSON.parse(localStorage.getItem('user')).id,
        UnidadeId: this.unidadeIds[0],
      }

      await this.apiService
        .post('alert/add', alert)
        .then(() => {})
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
    },

    async alterEquipment() {
      this.alterEquipmentLoading = true

      this.currentEquipment.contractValue = this.currentEquipment.contractValue
        ? this.currentEquipment.contractValue
        : 0
      this.currentEquipment.contractDollarValue = this.currentEquipment
        .contractDollarValue
        ? this.currentEquipment.contractDollarValue
        : 0

      const equipment = {
        Id: this.currentEquipment.id,
        ContractId: this.isRemoveEquipment
          ? null
          : this.currentEquipment.contractId,
        ContractValue: this.isRemoveEquipment
          ? 0
          : this.currentEquipment.contractValue,
        ContractDollarValue: this.isRemoveEquipment
          ? 0
          : this.currentEquipment.contractDollarValue,
      }

      await this.apiService
        .post('equipment/alterContract', equipment)
        .then((response) => {
          this.$emit('show', response.message)
          this.getContract()
          this.alterEquipmentLoading = false
          this.isRemoveEquipment = false
        })
        .catch((err) => {
          window.scrollTo(0, 0)
          this.errorMessage = err.body.message
          this.error = true
          this.alterEquipmentLoading = false
          this.isRemoveEquipment = false

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatInitialDate(dateInitial) {
      const date = new Date(dateInitial),
        day = date.getDate().toString(),
        dayF = day.length == 1 ? '0' + day : day,
        month = (date.getMonth() + 1).toString(),
        monthF = month.length == 1 ? '0' + month : month,
        yearF = date.getFullYear()
      return `${dayF}-${monthF}-${yearF}`
    },

    save(date) {
      this.startDate = this.formatInputDate(this.currentContract.startDate)
      this.$refs.menuStartDate.save(date)
      this.endDate = this.formatInputDate(this.currentContract.endDate)
      this.$refs.menuEndDate.save(date)
      this.readjustmentDate = this.formatInputDate(
        this.currentContract.readjustmentDate
      )
      this.$refs.menuReadjustmentDate.save(date)
    },
  },

  watch: {
    currentContract: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
    isInputable(v) {
      if (v) {
        this.currentContract.value = this.currentContract.equipment.reduce(
          (total, obj) => total + obj.contractValue,
          0
        )
      }
    },
  },
}
</script>
